// IMPORTANT!: DON'T make ANY changes about this class!!!! Required for devexpress Framework
export class SchedulerRow {
  text: string;
  startDate: Date;
  endDate: Date;
  recurrenceRule?: string;
}
